import React, { useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Switch, Route, Redirect } from "react-router-dom";
import {
  Paper,
  Typography,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import Teams from "./Teams";
import Players from "./Players";
import TeamDetail from "./TeamDetail";
import PlayerDetail from "./PlayerDetail";
import { gql, useQuery } from "@apollo/client";
import { useParams } from "react-router-dom";
import GameDetail from "./GameDetail";
import TableLink from "../TableLink";
import { DEFAULT_TITLE } from "../../constants";

const styles = theme => ({
  root: {
    maxWidth: 1200,
    marginTop: theme.spacing(5),
    padding: theme.spacing(2),
    overflowX: "auto",
    margin: "auto"
  }
});

const GET_TOURNAMENT = gql`
  query tournamentQuery($id: Int) {
    Tournament(id: $id) {
      name
      type
      address
      host
      url
      tournament_date {
        formatted
      }
      questionSet {
        id
        name
      }
    }
  }
`;

function Record({ classes, match, history }) {
  const { id } = useParams();
  const { loading, data, error } = useQuery(GET_TOURNAMENT, {
    variables: {
      id: parseInt(id)
    }
  });

  const handleCallToRouter = (_, value) => {
    history.push(`${match.url}${value}`);
  };

  const getTabValue = () => {
    var locationMatch = history.location.pathname.match(
      /\/tournament\/\d*(\/[\w-]*)(\/*)?/
    );

    return locationMatch ? locationMatch[1] : "teams";
  };

  useEffect(() => {
    document.title = `${
      !loading ? data.Tournament[0].name : "Tournament"
    } - ${DEFAULT_TITLE}`;
  });

  return (
    <Paper className={classes.root}>
      {loading && !error && <p>Loading...</p>}
      {error && !loading && <p>Error</p>}
      {data && !loading && !error && (
        <div>
          <Typography variant="h4" gutterBottom>
            {data.Tournament[0].name}
          </Typography>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Question Set</TableCell>
                <TableCell>Host</TableCell>
                <TableCell>Address</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  {new Date(
                    data.Tournament[0].tournament_date.formatted
                  ).toLocaleDateString()}
                </TableCell>
                <TableCell>{data.Tournament[0].type}</TableCell>
                <TableCell>
                  {data.Tournament[0].questionSet?.name ? (
                    <TableLink
                      to={`/questionset/${data.Tournament[0].questionSet?.id}`}
                    >
                      {data.Tournament[0].questionSet?.name}
                    </TableLink>
                  ) : (
                    "Unknown"
                  )}
                </TableCell>
                <TableCell>{data.Tournament[0].host || "Unknown"}</TableCell>
                <TableCell>{data.Tournament[0].address || "Unknown"}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <Tabs
            value={getTabValue()}
            onChange={handleCallToRouter}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab label="Teams" value="/teams"></Tab>
            <Tab label="Individuals" value="/individuals"></Tab>
            <Tab label="Team Detail" value="/team-detail"></Tab>
            <Tab label="Individual Detail" value="/individual-detail"></Tab>
            <Tab label="Game Detail" value="/game-detail"></Tab>
          </Tabs>
          <Switch>
            <Route path={`${match.path}/teams/:teamId?`} component={Teams} />
            <Route
              path={`${match.path}/individuals/:playerId?`}
              component={Players}
            />
            <Route
              path={`${match.path}/team-detail/:teamId?`}
              component={TeamDetail}
            />
            <Route
              path={`${match.path}/individual-detail/:playerId?`}
              component={PlayerDetail}
            />
            <Route
              path={`${match.path}/game-detail/:gameId?`}
              component={GameDetail}
            />
            <Redirect from={match.path} to={`${match.path}/teams`} />
          </Switch>
        </div>
      )}
    </Paper>
  );
}

export default withStyles(styles)(Record);
